module.exports = __webpack_public_path__ + "static/img/ikonaNotatnikDisabled-OFF.a8988f4d.png";